import {JACKPOTS_STORAGE_KEY, UPDATE_JACKPOTS} from "Redux/actions/jackpots";
import {getValueFromStorage} from "Helpers/storage";
import {CAN_VIEW_JACKPOTS} from "Setup/config";

let initialState = {isLoaded: false, publishTime: null, groups: []};

// Render last session's values straight away rather than waiting on the first call
if (CAN_VIEW_JACKPOTS) {
    const savedJackpots = getValueFromStorage(JACKPOTS_STORAGE_KEY);

    if (savedJackpots && Array.isArray(savedJackpots.groups)) {
        initialState = {...initialState, ...savedJackpots, isLoaded: true};
    }
}

const jackpotsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_JACKPOTS:
            return {
                ...state,
                isLoaded: true,
                publishTime: action.publishTime,
                groups: action.jackpotGroups,
            };
        default:
            return {
                ...state
            };
    }
};

export default jackpotsReducer;
